










































import { defineComponent, computed, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'ItemSelector',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    parentSelected: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      required: true,
    },
  },

  setup(props, context) {
    const selected = ref([]);
    const filteredItems = computed(() => props.items.filter((item: any) => !props.parentSelected.some((p: any) => p.id === item.id)));

    /**
     * Reset selected items
     * */
    function reset() {
      selected.value = [];
    }

    /**
     * Handler for close selector event
     * */
    function closeSelectorEventHandler() {
      context.emit('close');
      reset();
    }

    /**
     * Handler for select event
     * */
    function selectEventHandler() {
      context.emit('select-items', [...selected.value]);
      closeSelectorEventHandler();
    }

    return {
      selected,
      filteredItems,
      closeSelectorEventHandler,
      selectEventHandler,
    };
  }
});
